// project import
import admin from './admin';
import inventory from './inventory';
import menu from './menu';

// ==============================|| MENU ITEMS ||============================== //

export const navigation = {
  items: [admin, menu, inventory]
};
